import { render, staticRenderFns } from "./AgentAffiliate.vue?vue&type=template&id=47de4f3c&scoped=true&"
import script from "./AgentAffiliate.vue?vue&type=script&lang=js&"
export * from "./AgentAffiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de4f3c",
  null
  
)

export default component.exports